// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7b-0";
export var startPickingButton = "_7b-1";